<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode"  clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+loginUser.comtype === 1 ||  +loginUser.comtype === 3">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+loginUser.comtype === 1 || +loginUser.comtype === 2">
          <div class="label">经办人</div>
          <div class="field">
            <el-input v-model.trim="query.pUsername" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search" size="medium">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true" :defaultPage="10"
            :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  /* eslint-disable */
  export default {
    name: 'pbidConfirmIndex',
    data () {
      return {
        loginUser: this.$store.getters.loginUser,
        pUsernameDisabled: false,
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        projectStatusList: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          { field: 'projectlimitamtdesc',width:100, fieldtype: 'C', title: '项目预算',calculExpr:'',addNewRowFlg: false},
          { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'projectdoneflgdesc', fieldtype: 'C', title: '评审方法',calculExpr:'',addNewRowFlg: false, width: 120},
          // { field: 'projectjgfbflagdesc', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false},
          // { field: 'projecttime', fieldtype: 'T', title: '建项时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          {
            title: '通知书 ', width: 125, showOverflow: true,align: "center",
            slots: {
              default: 'default',
              default: ({row}) => {
                return [<vxe-button type='primary' onClick={this.todownload.bind(this, row)}>下载</vxe-button>]
              }
            }
          },
          {
            title: '操作', width: 130, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if (+row.psubidflgcount > 0) {
                  if (+row.projectstatus >= 40) {
                    return [
                      <vxe-button type='primary' onClick={this.toCJGG.bind(this,row)}>查看</vxe-button>
                    ]
                  } else {
                    return [
                      <vxe-button type='primary' onClick={this.projectResultNotice.bind(this,row)}>发布成交公告</vxe-button>
                      ]
                  }
                } else {
                  return [<vxe-button type='primary' onClick={this.setPsu.bind(this,row)}>确认成交</vxe-button>]
                }
              }
            }
          }
        ],
        project: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 10,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CONFIRM', () => this.setPsu()) 
      this.$on('FBJGGG', () => this.projectResultNotice())

      this.$on('CLOSE', () => this.close())
      if (+this.$store.getters.loginUser.comtype === 2 || +this.$store.getters.loginUser.comtype === 1) {
        if (+this.$store.getters.loginUser.comtype === 2 && +this.$store.getters.loginUser.roletype === 2) {
          this.query.pUsername = this.$store.getters.loginUser.username
          this.pUsernameDisabled = true
        }
        this.cols.splice(4, 0, {
          field: "pusername",
          fieldtype: "C",
          title: "经办人",
          calculExpr: "",
          addNewRowFlg: false,
          width: 80,
        })
      }
    },
    activated() {
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
      this.init()
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async projectResultNotice(row) {
        // this.$router.push({name: 'pjnoticeIndex', params: {projectid:row.projectid,type: 1}})
        this.$router.push({name: 'pbidConfirmForm', params: {form: row,innerbtn: this.btn.inner, type: 1}})
      },
      async toCJGG(row) {
        this.$router.push({name: 'pbidConfirmForm', params: {form: row,innerbtn: this.btn.inner, type: 1}})
      },
      async init() {
        // this.query = {
        //   cosid: this.$store.getters.loginUser.cosid,
        //   userid: this.$store.getters.loginUser.userid,
        //   comid: this.$store.getters.loginUser.comid,
        //   total: 0,
        //   limit: 10,
        //   offset: 0}
        // this.list = []
        this.btnLoading = false
        // this.project = {}
      },
      async todownload(row){
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getpsubcn',
          params: {projectid: row.projectid, yxflag: 1}
        })
        if(res.length>1){
          this.$router.push({name: 'pbidConfirmForm', params: {form: row,innerbtn: this.btn.inner, type: 1}})
        } else if(res.length === 1) {
          let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: res[0].psuid,projectid: row.projectid}})
          window.open(href, '_blank')
        } else {
          
          this.$message.warning('该项目还未有通知书！')
          return
        }
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async setPsu(row) {
        // if (!this.project.projectid) {
        //   this.$message.warning('请选择一个项目!')
        //   return
        // }
        this.$router.push({name: 'pbidConfirmForm', params: {form: row, type: 1}})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async viewProject(row) {
        this.project = row.row
        // if (+this.project.psubidflgcount > 0) {
        //   this.$router.push({name: 'projectResultNotice', params: {projectid:this.project.projectid,type: 1}})
        // } else {
        //   this.$router.push({name: 'pbidConfirmForm', params: {form: this.project,innerbtn: this.btn.inner, type: 1}})
        // }
        this.$router.push({name: 'pbidConfirmForm', params: {form: this.project,innerbtn: this.btn.inner, type: 1}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.selectField = `projectcode,projectlimitamt,projectptccode,projectname,projecttime,projectid,projectstatus`
        this.query.projectstatus= 30
        this.query.projectjjbgstatus= 3
        this.query.areaid = 0
        this.query.userid = this.$store.getters.loginUser.userid
        this.query.comid = this.$store.getters.loginUser.comid
        this.query.comtype = Number(this.$store.getters.loginUser.comtype)
        this.query.failproject = 1
        if (+this.$store.getters.loginUser.comtype === 2) {
          // 采购人
          // this.query.fromcode = 'cgjjreport'
          this.query.projecttype = '2'
        } else {
          this.query.projecttype = '1'
        }
        let res = {}
        if (+this.$store.getters.loginUser.comtype === 2) {
          res = await request({
            method: 'get',
            url: "/xmgl/project/getPurchaserPageList",
            params: this.query
          })
        } else {
          res = await request({
            method: 'get',
            url: '/xmgl/project/getPageList',
            params: this.query
          })
        }
        
        this.list = res.list
        this.list = this.list.map(v => {
          if (+v.psubidflgcount > 0) {
            v.projectjgfbflagdesc = +v.projectstatus === 40 ? '已发布' : '已确认'
          } else {
            v.projectjgfbflagdesc = '未确认'
          }
          v.projectlimitamtdesc =  v.projectlimitamt?utils.comdify(v.projectlimitamt):v.projectlimitamt
          return v
        })
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }

  }
</script>
<style lang="scss">

</style>
